import { HttpErrorResponse } from '@angular/common/http';
import { mapHttpErrorToModuleError } from 'src/app/shared/errors/map-http-error';
import { ModuleErrorView, createModuleError } from 'src/app/shared/errors/module-error.model';
import { parseViajesFirmaErrorMessage } from './viajes-firma.mapper';

/** El servidor respondió con un error de negocio. No corresponde reintentar el envío. */
export class ViajesFirmaRejectedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ViajesFirmaRejectedError';
  }
}

export function isTerminalFirmaSendError(err: unknown): boolean {
  if (err instanceof ViajesFirmaRejectedError) {
    return true;
  }
  if (err instanceof HttpErrorResponse) {
    const status = err.status;
    return status >= 400 && status < 500 && status !== 408;
  }
  return false;
}

export function firmaSendErrorMessage(err: unknown): string {
  if (err instanceof HttpErrorResponse) {
    const fromBody = parseViajesFirmaErrorMessage(err.error);
    if (fromBody !== 'La firma no pudo ser almacenada.') {
      return fromBody;
    }
  }
  if (err instanceof Error && err.message.trim()) {
    return err.message;
  }
  return 'Ocurrió un error al guardar la firma.';
}

export const VIAJES_FIRMA_ERROR_CODES = {
  INVALID_PAYLOAD: 'VIAJES_FIRMA_INVALID_PAYLOAD',
  ALREADY_SIGNED: 'VIAJES_FIRMA_ALREADY_SIGNED',
  SUBMIT_FAILED: 'VIAJES_FIRMA_SUBMIT_FAILED',
  NO_TOKEN: 'VIAJES_FIRMA_NO_TOKEN',
} as const;

export function mapViajesFirmaSubmitError(err: unknown): ModuleErrorView {
  if (err instanceof Error) {
    return createModuleError(VIAJES_FIRMA_ERROR_CODES.SUBMIT_FAILED, err.message, {
      recoverable: true,
    });
  }
  return mapHttpErrorToModuleError(err, parseViajesFirmaErrorMessage(err));
}

export function mapViajesFirmaAlreadySignedError(): ModuleErrorView {
  return createModuleError(
    VIAJES_FIRMA_ERROR_CODES.ALREADY_SIGNED,
    'Esta guía ya fue firmada.',
    { recoverable: false }
  );
}
